module.exports = __webpack_public_path__ + "img/round5.f8a760e0.png";